import { ProductItem } from './ProductItem';
import MoveHereLine from './MoveHereLine';
import { FC } from 'react';
import { CurrentProductList } from './SortingView';

interface Props {
    product: CurrentProductList & { rank: number };
    handleStatefulMove: (ndexInList: number) => void;
    handleStatelessMove: (currentProductRank: number, nextProductRank: number) => void;
    handleProductSelection: (product: CurrentProductList) => void;
    isProductChecked: boolean;
    isInSelectionMode: boolean;
    index: number;
}

const ProductItemWrapper: FC<Props> = ({
    product,
    handleStatefulMove,
    handleStatelessMove,
    handleProductSelection,
    isProductChecked,
    isInSelectionMode,
    index
}) => {
    return (
        <div key={product.rank}>
            {index === 0 ? (
                <MoveHereLine
                    indexInList={index}
                    isInSelectionMode={isInSelectionMode}
                    handleStatefulMove={handleStatefulMove}
                    handleStatelessMove={handleStatelessMove}
                />
            ) : null}
            <ProductItem
                currentRank={`${index}`}
                product={product}
                handleProductSelection={handleProductSelection}
                isSelected={isProductChecked}
                isInSelectionMode={isInSelectionMode}
            />
            <MoveHereLine
                indexInList={index + 1}
                isInSelectionMode={isInSelectionMode}
                handleStatefulMove={handleStatefulMove}
                handleStatelessMove={handleStatelessMove}
            />
        </div>
    );
};

export default ProductItemWrapper;
